// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Previous / Next exercise — BrandContext sets --brand-primary on :root */
button.table-setup-ex-nav-btn {
    cursor: pointer;
    transition: background-color 0.15s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}
button.table-setup-ex-nav-btn:not(:disabled) {
    background-color: var(--brand-primary, #0877BC);
}
button.table-setup-ex-nav-btn:not(:disabled):hover {
    background-color: var(--brand-primary-dark, #065a8f);
}
button.table-setup-ex-nav-btn:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
    box-shadow: none;
}

.table_setup_list {
    display: grid;
    /* grid-template-columns is set inline via style prop based on gridColumns state */
    gap: 20px;
    width: 100%;
}

.table_setups {
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    padding: 20px 10px 20px 10px;
    background: var(--surface-color, #fff);
    color: var(--text-color, inherit);
    cursor: pointer;
    min-height: 220px;
    height: 100%;
    box-shadow: 0 2px 12px var(--shadow-color, rgba(8, 119, 188, 0.12));
    border: 1px solid var(--border-color, transparent);
    width: 100%;
    overflow: visible;
    box-sizing: border-box;
}


.table_setups_content {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    width: 100%;
    position: relative;
    flex: 1 1 auto;
    min-height: 150px;
}

/* Equal-width P1 / P2 columns (not :first/:last — a third row would break those) */
.table_setups_content > [data-slot="player1"],
.table_setups_content > [data-slot="player2"] {
    flex: 1 1;
    min-width: 0;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    align-self: stretch;
    box-sizing: border-box;
    z-index: 2;
}

.table_setups_content > [data-slot="player1"] {
    align-items: flex-start;
    justify-content: flex-start;
}

.table_setups_content > [data-slot="player2"] {
    align-items: flex-end;
    justify-content: flex-end;
}

.table_cbicon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    padding: 0;
    box-sizing: border-box;
    z-index: 1;
    pointer-events: none;
}

.table_cbicon .table_title {
    margin-top: 5px;
    margin-bottom: 0;
}

.table_addplayer_title {
    font-size: 12px;
    color: #0877BC;
}

.table_title {
    font-size: 40px;
    font-weight: 700;
    color: #0877BC;
    margin: 0;
    text-align: center;
    letter-spacing: -0.02em;
}

.tableimg {
    width: 169px;
    height: auto;
    object-fit: contain;
    display: block;
}

/* Mobile responsive styles for table image */
@media(max-width: 650px) {
    .tableimg {
        width: 100px;
        max-width: 100px;
        height: auto;
    }
    
    .table_cbicon {
        opacity: 0.6; /* Make image slightly transparent on mobile so players are more visible */
    }
    
    .table_setups_content > [data-slot="player1"],
    .table_setups_content > [data-slot="player2"] {
        z-index: 3; /* Ensure player names are above the image */
    }
}

@media(max-width: 480px) {
    .tableimg {
        width: 80px;
        max-width: 80px;
        height: auto;
    }
    
    .table_cbicon {
        opacity: 0.5; /* Even more transparent on very small screens */
    }
}

.table_select_player {
    font-size: 10px;
    margin: 5px 0;
    outline: none;
    padding: 2px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
}

.table_player_name {
    font-size: 16px; /* Increased from 11px */
    font-weight: 600;
    min-width: 150px;
    width: 100%;
    cursor: grab;
}

.table_player_label_container {
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
    min-width: min(150px, 100%);
    margin-top: -4px;
    margin-bottom: 2px;
    padding-bottom: 2px;
    box-sizing: border-box;
}

/* Left slot: stats, name, meta align start; right slot: align end */
[data-slot="player1"] .table_player_label_container {
    align-items: flex-start;
}

[data-slot="player2"] .table_player_label_container {
    align-items: flex-end;
}

[data-slot="player3"] .table_player_label_container {
    align-items: center;
}

.table_player_stats {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    margin-bottom: 0;
    line-height: 1.25;
    max-width: 100%;
    box-sizing: border-box;
}

[data-slot="player1"] .table_player_stats {
    justify-content: flex-start;
}

[data-slot="player2"] .table_player_stats {
    justify-content: flex-end;
}

.table_player_stats__level {
    display: inline-block;
    font-weight: 700;
    font-size: 0.95em;
    letter-spacing: 0.02em;
    color: #fff;
    background: linear-gradient(135deg, #0877bc 0%, #065a8a 100%);
    padding: 3px 9px;
    border-radius: 6px;
    box-shadow: 0 1px 2px rgba(6, 90, 138, 0.25);
}

.table_player_stats__points {
    display: inline-block;
    font-weight: 600;
    font-size: 0.92em;
    color: #065a8a;
    font-variant-numeric: tabular-nums;
    padding: 2px 0;
}

.table_player_label {
    font-size: 16px; /* Increased from 12px */
    font-weight: 600;
    padding: 8px 12px;
    background-color: var(--bg-color, #f0f0f0);
    border: 2px solid #0877BC;
    border-radius: 8px;
    cursor: grab;
    text-align: center;
    min-width: min(120px, 100%);
    max-width: 100%;
    width: fit-content;
    display: inline-block;
    color: var(--brand-primary, #0877BC);
    transition: all 0.2s ease;
    box-sizing: border-box;
    word-break: break-word;
    overflow-wrap: anywhere;
    /* pan-y: scroll page when touching name; swap uses 500ms hold + JS (see --swap-armed) */
    touch-action: pan-y;
    user-select: none; /* Prevent text selection during drag */
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE/Edge */
}

[data-slot="player1"] .table_player_label {
    text-align: left;
}

[data-slot="player2"] .table_player_label {
    text-align: right;
}

[data-slot="player3"] .table_player_label {
    text-align: center;
}

.table_player_label:hover {
    background-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);
    border-color: #065a8a;
    transform: scale(1.02);
}

.table_player_label:active {
    cursor: grabbing;
    transform: scale(0.98);
}

/* Coach: double-click / double-tap name opens profile — extra press feedback */
.table_player_label.table_player_label--coach-profile:active {
    background-color: rgba(8, 119, 188, 0.16);
}

/* Player swap (coach): hold 0.5s then drag — visual phases */
.table_player_label.table_player_label--swap-holding {
    touch-action: none;
    position: relative;
    animation: tablePlayerSwapHoldRing 0.5s linear forwards;
    box-shadow: 0 0 0 0 rgba(8, 119, 188, 0.45);
}

@keyframes tablePlayerSwapHoldRing {
    0% {
        box-shadow: 0 0 0 0 rgba(8, 119, 188, 0.5);
    }
    70% {
        box-shadow: 0 0 0 6px rgba(8, 119, 188, 0.2);
    }
    100% {
        box-shadow: 0 0 0 8px rgba(8, 119, 188, 0.08);
    }
}

.table_player_label.table_player_label--swap-dragging {
    touch-action: none;
    opacity: 0.88;
    transform: scale(0.97);
    outline: 2px solid #0877bc;
    outline-offset: 2px;
    cursor: grabbing;
    z-index: 20;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
}

.table_player_label_slot--swap-drop-target {
    box-shadow: inset 0 0 0 3px #0877bc !important;
    background-color: rgba(8, 119, 188, 0.12) !important;
    border-radius: 8px;
}

.draggable {
    border: 1px solid #c1c1c1;
    cursor: grabbing;
}


.table_addplayer {
    font-size: 12px;
    padding: 0 5px;
    border: 1px solid #0877bc;
    background-color: #0877BC;
    color: #fff;
    cursor: pointer;
    border-radius: 3px;

}

@media(max-width:850px) {
    .table_setup_list {
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    }
}

@media(max-width:650px) {
    .table_setup_list {
        grid-template-columns: 1fr;
    }

    .table_select_player {
        font-size: 9px;
    }
}

/* Current Activity Info Styles */
.current-activity-info {
    background-color: #e0f7fa;
    border: 2px solid #00bcd4;
    border-radius: 8px;
    padding: 15px 20px;
    margin-bottom: 20px;
    box-shadow: 0 4px 12px rgba(0, 188, 212, 0.2);
    text-align: left;
}

.current-activity-info h3 {
    color: #00798c;
    font-size: 1.4rem;
    margin-top: 0;
    margin-bottom: 15px;
    border-bottom: 1px solid #b2ebf2;
    padding-bottom: 10px;
}

.current-exercise-details,
.current-sequence-details {
    margin-bottom: 10px;
}

.current-exercise-details p,
.current-sequence-details p {
    margin: 5px 0;
    font-size: 1rem;
    color: #333;
}

.current-exercise-details strong,
.current-sequence-details strong {
    color: #004d40;
    margin-right: 5px;
}

.player-roles-info {
    margin-top: 10px;
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.player-role-badge {
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 0.85rem;
    font-weight: bold;
    color: white;
}

.active-role {
    background-color: #4caf50;
}

.sparring-role {
    background-color: #ff9800;
}

/* Role pill on training table cards — hugs label text, wraps long translations */
.table_player_role_badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-top: 0;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: clamp(11px, 2.6vw, 13px);
    font-weight: 600;
    line-height: 1.25;
    letter-spacing: 0.01em;
    color: #fff;
    max-width: 100%;
    box-sizing: border-box;
    text-align: center;
    white-space: normal;
    word-break: break-word;
    hyphens: auto;
}

.table_player_role_badge--active {
    background-color: #4caf50;
}

.table_player_role_badge--sparring {
    background-color: #ff9800;
}

.table_player_role_badge--both {
    background-color: #2196f3;
}

/* Personalize mode hover glow on player names (colors from .session-setup CSS vars, set in TableSetup.jsx) */
.table_player_label.personalize-highlight:hover {
    background-color: var(--personalize-idle-hover-bg, rgba(70, 82, 139, 0.18)) !important;
    border-color: var(--personalize-active, #0877BC) !important;
    border-style: solid !important;
    box-shadow: 0 0 10px var(--personalize-active-glow, rgba(8, 119, 188, 0.35));
    transform: scale(1.04);
    color: var(--personalize-idle, #46528b);
    font-weight: 700;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(-6px); }
    to { opacity: 1; transform: translateY(0); }
}

/* Add players row — directly under session card; rotate/ranking row below it */
.session-setup__add-players {
    max-width: 1100px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 4px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.session-setup__table-actions {
    border-top: 1px solid rgba(0, 0, 0, 0.06);
    padding-top: 4px;
}

.table-setup-exercise-card__kot {
    width: 100%;
    margin-top: 16px;
}

.table-setup-exercise-card__kot .kot-settings--embedded {
    margin-top: 0;
    border-top: 1px solid rgba(8, 119, 188, 0.18);
    border-radius: 8px;
    padding: 12px;
}

.table-setup-exercise-card__kot-meta {
    margin-bottom: 10px;
    flex-wrap: wrap;
}

.table_setups--station {
    box-shadow: 0 2px 12px color-mix(in srgb, var(--psg-accent, #0877bc) 18%, transparent);
}

.table_setups__station-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--psg-accent, #0877bc);
    margin: 0 8px 8px;
}

.table_setups__extras {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    width: 100%;
    flex-basis: 100%;
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px dashed var(--border-color, #e8e8e8);
}

.table_setups__extra-chip {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    background: color-mix(in srgb, var(--psg-accent, #0877bc) 12%, var(--bg-color, #f5f5f5));
    color: var(--text-color, inherit);
}`, "",{"version":3,"sources":["webpack://./src/components/TableSetup.css"],"names":[],"mappings":"AAAA,0EAA0E;AAC1E;IACI,eAAe;IACf,uCAAuC;IACvC,yCAAyC;AAC7C;AACA;IACI,+CAA+C;AACnD;AACA;IACI,oDAAoD;AACxD;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kFAAkF;IAClF,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,4BAA4B;IAC5B,sCAAsC;IACtC,iCAAiC;IACjC,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,mEAAmE;IACnE,kDAAkD;IAClD,WAAW;IACX,iBAAiB;IACjB,sBAAsB;AAC1B;;;AAGA;IACI,aAAa;IACb,oBAAoB;IACpB,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA,mFAAmF;AACnF;;IAEI,SAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;IAC7B,UAAU;IACV,sBAAsB;IACtB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA,6CAA6C;AAC7C;IACI;QACI,YAAY;QACZ,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,YAAY,EAAE,0EAA0E;IAC5F;;IAEA;;QAEI,UAAU,EAAE,4CAA4C;IAC5D;AACJ;;AAEA;IACI;QACI,WAAW;QACX,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,YAAY,EAAE,gDAAgD;IAClE;AACJ;;AAEA;IACI,eAAe;IACf,aAAa;IACb,aAAa;IACb,YAAY;IACZ,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,eAAe,EAAE,wBAAwB;IACzC,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA,oEAAoE;AACpE;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;IACX,6DAA6D;IAC7D,gBAAgB;IAChB,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,eAAe,EAAE,wBAAwB;IACzC,gBAAgB;IAChB,iBAAiB;IACjB,0CAA0C;IAC1C,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,oCAAoC;IACpC,yBAAyB;IACzB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,wFAAwF;IACxF,mBAAmB;IACnB,iBAAiB,EAAE,uCAAuC;IAC1D,yBAAyB,EAAE,WAAW;IACtC,sBAAsB,EAAE,YAAY;IACpC,qBAAqB,EAAE,YAAY;AACvC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mEAAmE;IACnE,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,+EAA+E;AAC/E;IACI,yCAAyC;AAC7C;;AAEA,6DAA6D;AAC7D;IACI,kBAAkB;IAClB,kBAAkB;IAClB,uDAAuD;IACvD,2CAA2C;AAC/C;;AAEA;IACI;QACI,0CAA0C;IAC9C;IACA;QACI,4CAA4C;IAChD;IACA;QACI,6CAA6C;IACjD;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,0CAA0C;AAC9C;;AAEA;IACI,8CAA8C;IAC9C,oDAAoD;IACpD,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;;AAGA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,kBAAkB;;AAEtB;;AAEA;IACI;QACI,4DAA4D;IAChE;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA,iCAAiC;AACjC;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,6CAA6C;IAC7C,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;;IAEI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,iFAAiF;AACjF;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,mCAAmC;IACnC,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,6GAA6G;AAC7G;IACI,sFAAsF;IACtF,2DAA2D;IAC3D,8BAA8B;IAC9B,4EAA4E;IAC5E,sBAAsB;IACtB,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,+EAA+E;AAC/E;IACI,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,6CAA6C;IAC7C,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,sFAAsF;AAC1F;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,iCAAiC;IACjC,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mDAAmD;AACvD;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,wFAAwF;IACxF,iCAAiC;AACrC","sourcesContent":["/* Previous / Next exercise — BrandContext sets --brand-primary on :root */\nbutton.table-setup-ex-nav-btn {\n    cursor: pointer;\n    transition: background-color 0.15s ease;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n}\nbutton.table-setup-ex-nav-btn:not(:disabled) {\n    background-color: var(--brand-primary, #0877BC);\n}\nbutton.table-setup-ex-nav-btn:not(:disabled):hover {\n    background-color: var(--brand-primary-dark, #065a8f);\n}\nbutton.table-setup-ex-nav-btn:disabled {\n    background-color: #cccccc;\n    cursor: not-allowed;\n    box-shadow: none;\n}\n\n.table_setup_list {\n    display: grid;\n    /* grid-template-columns is set inline via style prop based on gridColumns state */\n    gap: 20px;\n    width: 100%;\n}\n\n.table_setups {\n    display: flex;\n    flex-direction: column;\n    border-radius: 8px;\n    padding: 20px 10px 20px 10px;\n    background: var(--surface-color, #fff);\n    color: var(--text-color, inherit);\n    cursor: pointer;\n    min-height: 220px;\n    height: 100%;\n    box-shadow: 0 2px 12px var(--shadow-color, rgba(8, 119, 188, 0.12));\n    border: 1px solid var(--border-color, transparent);\n    width: 100%;\n    overflow: visible;\n    box-sizing: border-box;\n}\n\n\n.table_setups_content {\n    display: flex;\n    align-items: stretch;\n    justify-content: space-between;\n    width: 100%;\n    position: relative;\n    flex: 1 1 auto;\n    min-height: 150px;\n}\n\n/* Equal-width P1 / P2 columns (not :first/:last — a third row would break those) */\n.table_setups_content > [data-slot=\"player1\"],\n.table_setups_content > [data-slot=\"player2\"] {\n    flex: 1 1 0;\n    min-width: 0;\n    max-width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-self: stretch;\n    box-sizing: border-box;\n    z-index: 2;\n}\n\n.table_setups_content > [data-slot=\"player1\"] {\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n.table_setups_content > [data-slot=\"player2\"] {\n    align-items: flex-end;\n    justify-content: flex-end;\n}\n\n.table_cbicon {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: transparent;\n    padding: 0;\n    box-sizing: border-box;\n    z-index: 1;\n    pointer-events: none;\n}\n\n.table_cbicon .table_title {\n    margin-top: 5px;\n    margin-bottom: 0;\n}\n\n.table_addplayer_title {\n    font-size: 12px;\n    color: #0877BC;\n}\n\n.table_title {\n    font-size: 40px;\n    font-weight: 700;\n    color: #0877BC;\n    margin: 0;\n    text-align: center;\n    letter-spacing: -0.02em;\n}\n\n.tableimg {\n    width: 169px;\n    height: auto;\n    object-fit: contain;\n    display: block;\n}\n\n/* Mobile responsive styles for table image */\n@media(max-width: 650px) {\n    .tableimg {\n        width: 100px;\n        max-width: 100px;\n        height: auto;\n    }\n    \n    .table_cbicon {\n        opacity: 0.6; /* Make image slightly transparent on mobile so players are more visible */\n    }\n    \n    .table_setups_content > [data-slot=\"player1\"],\n    .table_setups_content > [data-slot=\"player2\"] {\n        z-index: 3; /* Ensure player names are above the image */\n    }\n}\n\n@media(max-width: 480px) {\n    .tableimg {\n        width: 80px;\n        max-width: 80px;\n        height: auto;\n    }\n    \n    .table_cbicon {\n        opacity: 0.5; /* Even more transparent on very small screens */\n    }\n}\n\n.table_select_player {\n    font-size: 10px;\n    margin: 5px 0;\n    outline: none;\n    padding: 2px;\n    width: 100%;\n    max-width: 100%;\n    box-sizing: border-box;\n}\n\n.table_player_name {\n    font-size: 16px; /* Increased from 11px */\n    font-weight: 600;\n    min-width: 150px;\n    width: 100%;\n    cursor: grab;\n}\n\n.table_player_label_container {\n    width: 100%;\n    max-width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 6px;\n    min-width: min(150px, 100%);\n    margin-top: -4px;\n    margin-bottom: 2px;\n    padding-bottom: 2px;\n    box-sizing: border-box;\n}\n\n/* Left slot: stats, name, meta align start; right slot: align end */\n[data-slot=\"player1\"] .table_player_label_container {\n    align-items: flex-start;\n}\n\n[data-slot=\"player2\"] .table_player_label_container {\n    align-items: flex-end;\n}\n\n[data-slot=\"player3\"] .table_player_label_container {\n    align-items: center;\n}\n\n.table_player_stats {\n    display: inline-flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 6px;\n    margin-bottom: 0;\n    line-height: 1.25;\n    max-width: 100%;\n    box-sizing: border-box;\n}\n\n[data-slot=\"player1\"] .table_player_stats {\n    justify-content: flex-start;\n}\n\n[data-slot=\"player2\"] .table_player_stats {\n    justify-content: flex-end;\n}\n\n.table_player_stats__level {\n    display: inline-block;\n    font-weight: 700;\n    font-size: 0.95em;\n    letter-spacing: 0.02em;\n    color: #fff;\n    background: linear-gradient(135deg, #0877bc 0%, #065a8a 100%);\n    padding: 3px 9px;\n    border-radius: 6px;\n    box-shadow: 0 1px 2px rgba(6, 90, 138, 0.25);\n}\n\n.table_player_stats__points {\n    display: inline-block;\n    font-weight: 600;\n    font-size: 0.92em;\n    color: #065a8a;\n    font-variant-numeric: tabular-nums;\n    padding: 2px 0;\n}\n\n.table_player_label {\n    font-size: 16px; /* Increased from 12px */\n    font-weight: 600;\n    padding: 8px 12px;\n    background-color: var(--bg-color, #f0f0f0);\n    border: 2px solid #0877BC;\n    border-radius: 8px;\n    cursor: grab;\n    text-align: center;\n    min-width: min(120px, 100%);\n    max-width: 100%;\n    width: fit-content;\n    display: inline-block;\n    color: var(--brand-primary, #0877BC);\n    transition: all 0.2s ease;\n    box-sizing: border-box;\n    word-break: break-word;\n    overflow-wrap: anywhere;\n    /* pan-y: scroll page when touching name; swap uses 500ms hold + JS (see --swap-armed) */\n    touch-action: pan-y;\n    user-select: none; /* Prevent text selection during drag */\n    -webkit-user-select: none; /* Safari */\n    -moz-user-select: none; /* Firefox */\n    -ms-user-select: none; /* IE/Edge */\n}\n\n[data-slot=\"player1\"] .table_player_label {\n    text-align: left;\n}\n\n[data-slot=\"player2\"] .table_player_label {\n    text-align: right;\n}\n\n[data-slot=\"player3\"] .table_player_label {\n    text-align: center;\n}\n\n.table_player_label:hover {\n    background-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);\n    border-color: #065a8a;\n    transform: scale(1.02);\n}\n\n.table_player_label:active {\n    cursor: grabbing;\n    transform: scale(0.98);\n}\n\n/* Coach: double-click / double-tap name opens profile — extra press feedback */\n.table_player_label.table_player_label--coach-profile:active {\n    background-color: rgba(8, 119, 188, 0.16);\n}\n\n/* Player swap (coach): hold 0.5s then drag — visual phases */\n.table_player_label.table_player_label--swap-holding {\n    touch-action: none;\n    position: relative;\n    animation: tablePlayerSwapHoldRing 0.5s linear forwards;\n    box-shadow: 0 0 0 0 rgba(8, 119, 188, 0.45);\n}\n\n@keyframes tablePlayerSwapHoldRing {\n    0% {\n        box-shadow: 0 0 0 0 rgba(8, 119, 188, 0.5);\n    }\n    70% {\n        box-shadow: 0 0 0 6px rgba(8, 119, 188, 0.2);\n    }\n    100% {\n        box-shadow: 0 0 0 8px rgba(8, 119, 188, 0.08);\n    }\n}\n\n.table_player_label.table_player_label--swap-dragging {\n    touch-action: none;\n    opacity: 0.88;\n    transform: scale(0.97);\n    outline: 2px solid #0877bc;\n    outline-offset: 2px;\n    cursor: grabbing;\n    z-index: 20;\n    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);\n}\n\n.table_player_label_slot--swap-drop-target {\n    box-shadow: inset 0 0 0 3px #0877bc !important;\n    background-color: rgba(8, 119, 188, 0.12) !important;\n    border-radius: 8px;\n}\n\n.draggable {\n    border: 1px solid #c1c1c1;\n    cursor: grabbing;\n}\n\n\n.table_addplayer {\n    font-size: 12px;\n    padding: 0 5px;\n    border: 1px solid #0877bc;\n    background-color: #0877BC;\n    color: #fff;\n    cursor: pointer;\n    border-radius: 3px;\n\n}\n\n@media(max-width:850px) {\n    .table_setup_list {\n        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n    }\n}\n\n@media(max-width:650px) {\n    .table_setup_list {\n        grid-template-columns: 1fr;\n    }\n\n    .table_select_player {\n        font-size: 9px;\n    }\n}\n\n/* Current Activity Info Styles */\n.current-activity-info {\n    background-color: #e0f7fa;\n    border: 2px solid #00bcd4;\n    border-radius: 8px;\n    padding: 15px 20px;\n    margin-bottom: 20px;\n    box-shadow: 0 4px 12px rgba(0, 188, 212, 0.2);\n    text-align: left;\n}\n\n.current-activity-info h3 {\n    color: #00798c;\n    font-size: 1.4rem;\n    margin-top: 0;\n    margin-bottom: 15px;\n    border-bottom: 1px solid #b2ebf2;\n    padding-bottom: 10px;\n}\n\n.current-exercise-details,\n.current-sequence-details {\n    margin-bottom: 10px;\n}\n\n.current-exercise-details p,\n.current-sequence-details p {\n    margin: 5px 0;\n    font-size: 1rem;\n    color: #333;\n}\n\n.current-exercise-details strong,\n.current-sequence-details strong {\n    color: #004d40;\n    margin-right: 5px;\n}\n\n.player-roles-info {\n    margin-top: 10px;\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.player-role-badge {\n    padding: 5px 10px;\n    border-radius: 5px;\n    font-size: 0.85rem;\n    font-weight: bold;\n    color: white;\n}\n\n.active-role {\n    background-color: #4caf50;\n}\n\n.sparring-role {\n    background-color: #ff9800;\n}\n\n/* Role pill on training table cards — hugs label text, wraps long translations */\n.table_player_role_badge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 0;\n    padding: 4px 10px;\n    border-radius: 999px;\n    font-size: clamp(11px, 2.6vw, 13px);\n    font-weight: 600;\n    line-height: 1.25;\n    letter-spacing: 0.01em;\n    color: #fff;\n    max-width: 100%;\n    box-sizing: border-box;\n    text-align: center;\n    white-space: normal;\n    word-break: break-word;\n    hyphens: auto;\n}\n\n.table_player_role_badge--active {\n    background-color: #4caf50;\n}\n\n.table_player_role_badge--sparring {\n    background-color: #ff9800;\n}\n\n.table_player_role_badge--both {\n    background-color: #2196f3;\n}\n\n/* Personalize mode hover glow on player names (colors from .session-setup CSS vars, set in TableSetup.jsx) */\n.table_player_label.personalize-highlight:hover {\n    background-color: var(--personalize-idle-hover-bg, rgba(70, 82, 139, 0.18)) !important;\n    border-color: var(--personalize-active, #0877BC) !important;\n    border-style: solid !important;\n    box-shadow: 0 0 10px var(--personalize-active-glow, rgba(8, 119, 188, 0.35));\n    transform: scale(1.04);\n    color: var(--personalize-idle, #46528b);\n    font-weight: 700;\n}\n\n@keyframes fadeIn {\n    from { opacity: 0; transform: translateY(-6px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n/* Add players row — directly under session card; rotate/ranking row below it */\n.session-setup__add-players {\n    max-width: 1100px;\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 4px;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n}\n\n.session-setup__table-actions {\n    border-top: 1px solid rgba(0, 0, 0, 0.06);\n    padding-top: 4px;\n}\n\n.table-setup-exercise-card__kot {\n    width: 100%;\n    margin-top: 16px;\n}\n\n.table-setup-exercise-card__kot .kot-settings--embedded {\n    margin-top: 0;\n    border-top: 1px solid rgba(8, 119, 188, 0.18);\n    border-radius: 8px;\n    padding: 12px;\n}\n\n.table-setup-exercise-card__kot-meta {\n    margin-bottom: 10px;\n    flex-wrap: wrap;\n}\n\n.table_setups--station {\n    box-shadow: 0 2px 12px color-mix(in srgb, var(--psg-accent, #0877bc) 18%, transparent);\n}\n\n.table_setups__station-label {\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: var(--psg-accent, #0877bc);\n    margin: 0 8px 8px;\n}\n\n.table_setups__extras {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    width: 100%;\n    flex-basis: 100%;\n    margin-top: 8px;\n    padding-top: 8px;\n    border-top: 1px dashed var(--border-color, #e8e8e8);\n}\n\n.table_setups__extra-chip {\n    display: inline-flex;\n    align-items: center;\n    padding: 4px 10px;\n    border-radius: 999px;\n    font-size: 12px;\n    font-weight: 600;\n    background: color-mix(in srgb, var(--psg-accent, #0877bc) 12%, var(--bg-color, #f5f5f5));\n    color: var(--text-color, inherit);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
